import React from "react";
import { ManualParallax } from "./ManualParallax/ManualParallax"

export default function App() {
  return (
    <div>
      <ManualParallax />
      {/* <ModuleParallax /> */}
    </div>
  )
}